import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";

import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import ValidateService from "../../../components/ValidateService/ValidateService";

//SERVICE
import { P240GetDataList } from "../../../service/200/P240Service";

export default function P240() {
    const toast = useRef(null);
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData, setSearchData] = useState({
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    // DATA
    const [dataForm, setDataForm] = useState([]);
    const [dataSubmit, setDataSubmit] = useState(null);
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        if (dataUserSession()) {
            setSearchData({ userId: dataUserSession().userId });
            setDataSubmit(history.location.state.contractNo)
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetSupervisorContractList();
    }, [searchData]);

    const onGetSupervisorContractList = () => {
        setLoading(true);
        P240GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataForm(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const submitForm = () => {
        if (dataSubmit != null) {
            history.push({
                pathname: "/241",
                state: { dataSrh: { contractNo: dataSubmit }, form: "/240" },
            });
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">แบบประเมิน 3 มิติ</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3"></div>
                            <div className="p-field p-col-12 p-md-6">
                                <label htmlFor="requestNo">เลขที่สัญญา</label>
                                <Dropdown id="requestNo" type="text" value={dataSubmit} options={dataForm} optionValue="contractNo" optionLabel="contractNo" onChange={(e) => setDataSubmit(e.value)} placeholder="เลือก เลขที่สัญญา" />
                            </div>
                        </div>

                        <div className="p-grid" style={{ textAlign: "center",marginTop:10 }}>
                            <div className="p-col-12">
                                <Button
                                    className="p-button-primary p-button btn-srh-responsive"
                                    icon="pi pi-search"
                                    label="ค้นหา"
                                    style={{ width: 120,marginLeft: "5px", marginTop:'10px' }}
                                    onClick={() => submitForm()}
                                />
                                <Button
                                    className="p-button-secondary p-button btn-long-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอแสดงรายการ"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 250,marginLeft: "5px", marginTop:'10px' }}
                                    onClick={()=> history.push("/208")}
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}
